import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-6 ml-4" }
const _hoisted_2 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-3 pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = { class: "space-y-6 ml-4" }
const _hoisted_5 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "py-1" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.$t('partnerManagement.route.detailHub'),
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: () => {}
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, {
          label: _ctx.$t('partnerManagement.route.detailHub')
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.list.codeHub'),
            value: _ctx.hubData?.hubCode
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2 capitalize",
            label: _ctx.$t('partnerManagement.list.nameHub'),
            value: _ctx.hubData.hubName
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.list.kotaHub'),
            value: _ctx.hubData.originCity
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: "Alamat",
            value: _ctx.hubData.hubAddress
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2 capitalize",
            label: _ctx.$t('partnerManagement.list.kecamatanKota'),
            value: _ctx.hubData.hubDistrict
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.detail.phone'),
            value: _ctx.formatPhoneDisplay(_ctx.hubData.hubPhoneNumber)
          }, null, 8, ["label", "value"])
        ])
      ]),
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Title, {
          label: _ctx.$t('partnerManagement.detail.contactInfo')
        }, null, 8, ["label"]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.detail.name'),
            value: _ctx.hubData.hubContactPersonName
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.detail.phone'),
            value: _ctx.formatPhoneDisplay(_ctx.hubData.hubContactPersonPhoneNumber)
          }, null, 8, ["label", "value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: _ctx.$t('partnerManagement.detail.email'),
            value: _ctx.hubData.hubContactPersonEmail
          }, null, 8, ["label", "value"])
        ])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('partnerManagement.list.status')
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_6, [
            _createVNode("span", {
              class: [_ctx.hubDataStatus == 'Aktif' ? 'bg-green-lp-300 text-green-lp-400' : 'bg-red-lp-600 text-red-lp-200', "px-2 py-0.5 font-medium rounded-2xl mt-6"]
            }, _toDisplayString(_ctx.hubDataStatus), 3)
          ])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('partnerManagement.detail.createdAt'),
        value: _ctx.hubCreatedAtFormatted,
        caption: _ctx.hubData.hubCreatedBy
      }, null, 8, ["label", "value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('partnerManagement.detail.lastUpdated'),
        value: _ctx.hubUpdatedAtFormatted,
        caption: _ctx.hubData.hubUpdatedBy
      }, null, 8, ["label", "value", "caption"]),
      (_ctx.isEditAble)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            title: "Ubah",
            onClick: _ctx.goToEdit,
            outline: "",
            customClass: "w-40 mt-6",
            textColor: "red-lp-100"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _hoisted_7
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}